import { render } from "./MenuItemsModal.vue?vue&type=template&id=5eb36c97"
import script from "./MenuItemsModal.vue?vue&type=script&lang=js"
export * from "./MenuItemsModal.vue?vue&type=script&lang=js"

import "./MenuItemsModal.vue?vue&type=style&index=0&id=5eb36c97&lang=scss&scope=true"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__